import { AuthShell, SignInForm, useAuth } from "@nexys/user-management-web";
import { useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

export const SignInPage = () => {
  const { status, refresh } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const redirectTo =
    (location.state as { from?: string } | null)?.from ?? "/";

  // If we land here already signed in (e.g. someone hit /sign-in from
  // the menu), bounce to the target route instead of asking them to
  // log in twice.
  useEffect(() => {
    if (status === "authenticated") navigate(redirectTo, { replace: true });
  }, [status, navigate, redirectTo]);

  return (
    <AuthShell brand="UM-RS Console">
      <SignInForm
        onSuccess={async () => {
          await refresh();
          navigate(redirectTo, { replace: true });
        }}
        forgotPasswordSlot={
          <Link
            to="/forgot-password"
            className="text-xs text-primary hover:underline"
          >
            Forgot password?
          </Link>
        }
        signUpSlot={
          <>
            Don't have an account?{" "}
            <Link to="/sign-up" className="font-medium text-primary hover:underline">
              Sign up
            </Link>
          </>
        }
      />
    </AuthShell>
  );
};
